import React, { useEffect, useRef, useState } from 'react'
import AllProductsStyle from './AllProducts'
import Button from '../../components/Button'
import { useNavigate } from 'react-router-dom'
import api, { customFuncsApi } from '../../api'
import { get } from 'lodash'
import Layout from '../../components/Layout'
import { ErrorModal } from '../../components/Modal'
import ClipLoader from 'react-spinners/ClipLoader'
import moment from 'moment'
import { isAxiosError } from 'axios'
import _ from 'lodash'
import { instalmentPlan } from '../../store/slices'
import { useDispatch, useSelector } from 'react-redux'
import customMainApi from '../../api/index'
import dayjs from 'dayjs'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import { Empty, DatePicker, Input, Button as AntButton, Table } from 'antd'
import { useTranslation } from 'react-i18next'
import useEnterKey from '../../hooks/useEnterKey'
import RenderTableHeader from '../../components/TableHeader'
import RenderTableRow from '../../components/TableRow'
import { debouncedSet } from '../../utils/debounce'
import { checkValueToNotNull } from '../../utils/checkValue'
import useWindowFocus from '../../hooks/useWindowFocus'

import {
	ArrowUpOutlined,
	ArrowDownOutlined,
	ArrowsAltOutlined,
} from '@ant-design/icons'

const { RangePicker } = DatePicker

const handleBusinessPartner = _.debounce((searchFunc, value) => {
	searchFunc(value)
}, 1000)

const AllProducts = () => {
	dayjs.extend(advancedFormat)
	dayjs.extend(customParseFormat)

	const { t } = useTranslation()

	const {
		setClient: setClientStore,
		setImei: setImeiStore,
		setCardCode: setCardCodeStore,
	} = instalmentPlan.actions
	const {
		client: clientStore,
		imei: imeiStore,
		cardCode: cardCodeStore,
	} = useSelector((state) => state.instalmentPlan)
	const dispatch = useDispatch()
	const { getMe } = useSelector((state) => state.main)

	const errorRef = useRef()
	const dateFormat = 'YYYY-MM-DD'
	const [dateStart, setDateStart] = useState('2010-01-01')

	const [dateEnd, setDateEnd] = useState(dayjs().format(dateFormat))
	const [phoneNum, setPhoneNum] = useState('')

	const [isLoading, setIsLoading] = useState(false)
	const [clientLoading, setClientLoading] = useState(false)
	const [client, setClient] = useState(clientStore)
	const [clientCode, setClientCode] = useState(cardCodeStore)
	const [imeiClient, setImeiClient] = useState('')
	const [product, setProduct] = useState('')
	const [data, setData] = useState([])
	const [currentPage, setCurrentPage] = useState(0)
	const [clientsData, setClientsData] = useState([])
	const [userFields, setUserFields] = useState([])
	const [sortConfig, setSortConfig] = useState({
		column: null,
		direction: null,
	})
	const [commentsOrIcloud, setCommentsOrIcloud] = useState('')

	const focused = useWindowFocus()

	const search = (sortConfig) => {
		setIsLoading(true)
		customFuncsApi
			.get(
				`XsSql/getInvoices${sortConfig.direction !== null ? `?orderBy=[{"name": "${sortConfig.column}", "type" : "${sortConfig.direction}"}]` : ``}`,
				{
					params: {
						type: 'manyinst',
						$skip: currentPage,
						IntrSerial: imeiClient || undefined,
						CardCode: client && clientCode ? clientCode : undefined,
						itemCode: product || undefined,
						date1: `${dateStart}T00:00:00.000Z`,
						date2: `${dateEnd}T00:00:00.000Z`,
						U_Telephone: phoneNum,
						CommentsOrIcloud: commentsOrIcloud,
					},
					headers: {
						Prefer: 'odata.maxpagesize=10',
					},
				},
			)
			.then((res) => {
				const resData = res.data.value || []
				setData(resData)
				setIsLoading(false)
			})
			.catch((err) => {
				if (isAxiosError(err)) errorRef.current?.open(get(err, 'message', ''))
				setIsLoading(false)
			})
	}

	useEffect(() => {
		if (focused) {
			search(sortConfig)
		}
	}, [focused])

	useEffect(() => {
		userFieldsFn()
	}, [])

	const userFieldsFn = () => {
		customMainApi
			.get('UserFieldsMD', {
				params: {
					$filter: "TableName eq 'OITM' ",
				},
			})
			.then((res) => {
				setUserFields(JSON.parse(res.data).value)
			})
	}

	useEffect(() => {
		if (!client) {
			dispatch(setClientStore(client))
		}
	}, [client])

	const businessPartners = async (value) => {
		setClientLoading(true)
		const formattedName = value.includes("'")
			? value.replace(/'/g, "''")
			: value

		api
			.get(`BusinessPartners`, {
				params: {
					$select: 'CardCode, CardName, U_Telephone',
					$filter: `contains(CardName, '${formattedName}') or contains(U_Telephone, '${formattedName}') or contains(CardCode, '${formattedName}') and CardType eq 'cCustomer' and Frozen eq 'tNO'`,
				},
				headers: {
					Prefer: 'odata.maxpagesize=20',
				},
			})
			.then((res) => {
				setClientsData(JSON.parse(res.data).value || [])
				setClientLoading(false)
			})
			.catch((err) => {
				if (isAxiosError(err)) errorRef.current?.open(get(err, 'message', ''))
				setIsLoading(false)
			})
	}

	useEffect(() => {
		search(sortConfig)
	}, [currentPage, sortConfig])

	const viewItem = (v) => {
		const url = `/viewItem?data=${encodeURIComponent(JSON.stringify(v))}&DocEntry=${v.DocEntry}`
		window.open(url, '_blank')
	}

	const newDatas = () => {
		if (data.length >= 10) {
			setCurrentPage(currentPage + 10)
		} else {
			alert(t('noOtherInfo'))
		}
	}

	const oldData = () => {
		if (data.oldPage < 0) {
			alert(t('noOtherInfo'))
		} else {
			setCurrentPage(currentPage - 10)
		}
	}

	const handleSearch = () => {
		search(sortConfig)
	}

	const handleSort = (column) => {
		let direction = 'ASC'
		if (sortConfig.column === column && sortConfig.direction === 'ASC') {
			direction = 'DESC'
		} else if (
			sortConfig.column === column &&
			sortConfig.direction === 'DESC'
		) {
			direction = null
		}
		setSortConfig({ column, direction })
	}
	const handlePhoneChange = (val) => {
		debouncedSet(val, setPhoneNum)
	}

	const onRangeChange = (dates, dateStrings) => {
		if (dates) {
			const start = dates[0]
			const end = dates[1]

			setDateStart(start ? start.format('YYYY-MM-DD') : null)
			setDateEnd(end ? end.format('YYYY-MM-DD') : null)
		} else {
			console.error('Clear in Installment Plan ')
		}
	}

	useEnterKey(() => handleSearch())

	return (
		<Layout>
			<AllProductsStyle>
				<div className="container minWidthContainer">
					<p className="productTitle">{t('installment-plan')}</p>
					<div className="flex items-center flex-col sm:flex-row justify-between items-center">
						<div className="flex items-center flex-col sm:flex-row mt-10 mb-10 gap-8">
							<div className="relative">
								<Input
									className={
										'border-[1px] border-[#d9d9d9] p-2 rounded-md w-[300px]'
									}
									allowClear
									type="text"
									placeholder={t('client')}
									value={client}
									onChange={(e) => {
										setClient(e.target.value)
										handleBusinessPartner(businessPartners, e.target.value)
									}}
								/>
								{client && (
									<div className="absolute top-11 left-0 bg-white w-full z-10 border-[1px] border-[#d9d9d9] max-h-[300px] overflow-y-scroll">
										{clientsData.map((v, i) => {
											return (
												<div
													key={i}
													className="p-2 border-b cursor-pointer hover:bg-gray-100"
													onClick={() => {
														dispatch(setCardCodeStore(v.CardCode))
														dispatch(setClientStore(v.CardName))
														setClientCode(v.CardCode)
														setClient(v.CardName)
														setClientsData([])
													}}
												>
													{v.CardName}
												</div>
											)
										})}
									</div>
								)}
							</div>
							<Input
								allowClear
								className={'border-[1px] border-[#d9d9d9"] p-2 rounded-md '}
								type="text"
								placeholder={t('imei')}
								defaultValue={imeiClient}
								value={imeiClient}
								onChange={(v) => {
									setImeiClient(v.target.value)
								}}
							/>
							{get(getMe, 'Department2.Name', '') === 'DokonManager' ||
							get(getMe, 'Department2.Name', '') === 'Sotuv' ||
							get(getMe, 'Department2.Name', '') === 'Cashier' ||
							get(getMe, 'Department2.Name', '') === 'Boshqaruv' ? (
								<Input
									allowClear
									className={'border-[1px] border-[#d9d9d9"] p-2 rounded-md '}
									placeholder={t('phoneNumber')}
									onChange={(e) => handlePhoneChange(e.target.value)}
									type="text"
								/>
							) : null}

							<Input
								allowClear
								className={'border-[1px] border-[#d9d9d9"] p-2 rounded-md '}
								placeholder={t('Комментарии или Icloud')}
								onChange={(e) => setCommentsOrIcloud(e.target.value)}
								type="text"
							/>
							<div className="flex flex-col w-full">
								<RangePicker
									value={[
										dateStart ? dayjs(dateStart, dateFormat) : null,
										dateEnd ? dayjs(dateEnd, dateFormat) : null,
									]}
									format={dateFormat}
									onChange={onRangeChange}
									className='border-[1px] border-[#DFE2E9"] p-2 rounded-md min-w-[240px] w-full '
								/>
							</div>

							<div className="w-full">
								<AntButton
									className={
										'w-full h-[40px] bg-[#0A4D68] text-white sm:w-[80px]'
									}
									onClick={() => handleSearch()}
									loading={isLoading}
								>
									{t('search')}
								</AntButton>
							</div>
						</div>
						<AntButton
							className="w-full h-[40px] bg-[#0A4D68] text-white sm:w-[100px]  "
							onClick={() =>
								window.open('/createProducts-installment', '_blank')
							}
						>
							{t('add')}
						</AntButton>
					</div>

					{isLoading ? (
						<ClipLoader
							loading={true}
							size={75}
							aria-label="Loading Spinner"
							className={'loader'}
							data-testid="loader"
						/>
					) : (
						<>
							<div className="overflow-y-auto mb-8 mt-5">
								<table className="w-full text-sm text-left rtl:text-right text-gray-500 ">
									<thead className="text-xs text-gray-700 uppercase bg-gray-50 ">
										<tr>
											<th
												scope="col"
												className="px-6 py-4 cursor-pointer"
												onClick={() => handleSort('CardCode')}
											>
												<div className="flex items-center justify-start gap-1">
													<span>{t('clientCode')}</span>
													<div>
														{sortConfig.column === 'CardCode' ? (
															sortConfig.direction === 'ASC' ? (
																<ArrowUpOutlined />
															) : sortConfig.direction === 'DESC' ? (
																<ArrowDownOutlined />
															) : (
																<span className="flex gap-0.5 items-start justify-start">
																	<ArrowUpOutlined />
																	<ArrowDownOutlined />
																</span>
															)
														) : (
															<span className="flex gap-0.5 items-start justify-start">
																<ArrowUpOutlined />
																<ArrowDownOutlined />
															</span>
														)}
													</div>
												</div>
											</th>
											<th
												scope="col"
												className="px-6 py-4 cursor-pointer"
												onClick={() => handleSort('CardName')}
											>
												<div className="flex items-center justify-start gap-1">
													<span>{t('clientName')}</span>
													{sortConfig.column === 'CardName' ? (
														sortConfig.direction === 'ASC' ? (
															<ArrowUpOutlined />
														) : sortConfig.direction === 'DESC' ? (
															<ArrowDownOutlined />
														) : (
															<span className="flex gap-0.5 items-start justify-start">
																<ArrowUpOutlined />
																<ArrowDownOutlined />
															</span>
														)
													) : (
														<span className="flex gap-0.5 items-start justify-start">
															<ArrowUpOutlined />
															<ArrowDownOutlined />
														</span>
													)}
												</div>
											</th>

											{/* <th scope="col" className="px-6 py-4 cursor-pointer"
												onClick={() => handleSort('CardCode')}>
												Гарант
											</th> */}
											<th
												scope="col"
												className="px-6 py-4 cursor-pointer"
												onClick={() => handleSort('IntrSerial')}
											>
												<div className="flex items-center justify-start gap-1">
													<span>{t('imei')}</span>
													<div>
														{sortConfig.column === 'IntrSerial' ? (
															sortConfig.direction === 'ASC' ? (
																<ArrowUpOutlined />
															) : sortConfig.direction === 'DESC' ? (
																<ArrowDownOutlined />
															) : (
																<span className="flex gap-0.5 items-start justify-start">
																	<ArrowUpOutlined />
																	<ArrowDownOutlined />
																</span>
															)
														) : (
															<span className="flex gap-0.5 items-start justify-start">
																<ArrowUpOutlined />
																<ArrowDownOutlined />
															</span>
														)}
													</div>
												</div>
											</th>
											<th
												scope="col"
												className="px-20  cursor-pointer"
												onClick={() => handleSort('Dscription')}
											>
												<div className="flex items-center justify-start gap-1">
													<span>{t('product')}</span>
													<div>
														{sortConfig.column === 'Dscription' ? (
															sortConfig.direction === 'ASC' ? (
																<ArrowUpOutlined />
															) : sortConfig.direction === 'DESC' ? (
																<ArrowDownOutlined />
															) : (
																<span className="flex gap-0.5 items-start justify-start">
																	<ArrowUpOutlined />
																	<ArrowDownOutlined />
																</span>
															)
														) : (
															<span className="flex gap-0.5 items-start justify-start">
																<ArrowUpOutlined />
																<ArrowDownOutlined />
															</span>
														)}
													</div>
												</div>
											</th>
											<th
												scope="col"
												className="px-6 py-4 cursor-pointer"
												onClick={() => handleSort('U_DaftarBet')}
											>
												<div className="flex items-center justify-start gap-1">
													<span>{t('pageNumber')}</span>
													<div>
														{sortConfig.column === 'U_DaftarBet' ? (
															sortConfig.direction === 'ASC' ? (
																<ArrowUpOutlined />
															) : sortConfig.direction === 'DESC' ? (
																<ArrowDownOutlined />
															) : (
																<span className="flex gap-0.5 items-start justify-start">
																	<ArrowUpOutlined />
																	<ArrowDownOutlined />
																</span>
															)
														) : (
															<span className="flex gap-0.5 items-start justify-start">
																<ArrowUpOutlined />
																<ArrowDownOutlined />
															</span>
														)}
													</div>
												</div>
											</th>
											<th
												scope="col"
												className="px-6 py-4 cursor-pointer"
												onClick={() => handleSort('U_Security.Name')}
											>
												<div className="flex items-center justify-start gap-1">
													<span>{t('icloud')}</span>
													<div>
														{sortConfig.column === 'U_Security.Name' ? (
															sortConfig.direction === 'ASC' ? (
																<ArrowUpOutlined />
															) : sortConfig.direction === 'DESC' ? (
																<ArrowDownOutlined />
															) : (
																<span className="flex gap-0.5 items-start justify-start">
																	<ArrowUpOutlined />
																	<ArrowDownOutlined />
																</span>
															)
														) : (
															<span className="flex gap-0.5 items-start justify-start">
																<ArrowUpOutlined />
																<ArrowDownOutlined />
															</span>
														)}
													</div>
												</div>
											</th>
											<th
												scope="col"
												className="px-6 py-4 cursor-pointer"
												onClick={() => handleSort('U_Score.Name')}
											>
												<div className="flex items-center justify-start gap-1">
													<span>{t('status')}</span>
													<div>
														{sortConfig.column === 'U_Score.Name' ? (
															sortConfig.direction === 'ASC' ? (
																<ArrowUpOutlined />
															) : sortConfig.direction === 'DESC' ? (
																<ArrowDownOutlined />
															) : (
																<span className="flex gap-0.5 items-start justify-start">
																	<ArrowUpOutlined />
																	<ArrowDownOutlined />
																</span>
															)
														) : (
															<span className="flex gap-0.5 items-start justify-start">
																<ArrowUpOutlined />
																<ArrowDownOutlined />
															</span>
														)}
													</div>
												</div>
											</th>

											<th
												scope="col"
												className="px-6 py-4 cursor-pointer"
												onClick={() => handleSort('DueToDate')}
											>
												<div className="flex items-center justify-start gap-1">
													<span>{t('debtToday')}</span>
													<div>
														{sortConfig.column === 'DueToDate' ? (
															sortConfig.direction === 'ASC' ? (
																<ArrowUpOutlined />
															) : sortConfig.direction === 'DESC' ? (
																<ArrowDownOutlined />
															) : (
																<span className="flex gap-0.5 items-start justify-start">
																	<ArrowUpOutlined />
																	<ArrowDownOutlined />
																</span>
															)
														) : (
															<span className="flex gap-0.5 items-start justify-start">
																<ArrowUpOutlined />
																<ArrowDownOutlined />
															</span>
														)}
													</div>
												</div>
											</th>
											<th
												scope="col"
												className="px-6 py-4 cursor-pointer"
												onClick={() => handleSort('DebtTotal')}
											>
												<div className="flex items-center justify-start gap-1">
													<span>{t('debtTotal')}</span>
													<div>
														{sortConfig.column === 'DebtTotal' ? (
															sortConfig.direction === 'ASC' ? (
																<ArrowUpOutlined />
															) : sortConfig.direction === 'DESC' ? (
																<ArrowDownOutlined />
															) : (
																<span className="flex gap-0.5 items-start justify-start">
																	<ArrowUpOutlined />
																	<ArrowDownOutlined />
																</span>
															)
														) : (
															<span className="flex gap-0.5 items-start justify-start">
																<ArrowUpOutlined />
																<ArrowDownOutlined />
															</span>
														)}
													</div>
												</div>
											</th>

											<th scope="col" className="px-6 py-4">
												{t('monthlyPayment')}
											</th>
											<RenderTableHeader
												title="dateOfSale"
												sortColumn="DocDate"
												handleSort={handleSort}
												sortConfig={sortConfig}
												isSortable
											/>
											<RenderTableHeader title="lastComment" />
											<RenderTableHeader
												title="lastCommentDate"
												sortColumn="U_COMMENTS.U_CreateTime"
												handleSort={handleSort}
												sortConfig={sortConfig}
												isSortable
											/>
										</tr>
									</thead>
									<tbody>
										{data.length > 0 ? (
											data.map((v, i) => {
												const color =
													get(v, 'U_Color', '') !== ''
														? userFields
																?.find((item) => item.Name === 'Color')
																?.ValidValuesMD.find(
																	(value) =>
																		get(v, 'U_Color', '') === value.Value,
																)?.Description || ''
														: ''

												const memory =
													get(v, 'U_Memory', '') !== ''
														? userFields
																?.find((item) => item.Name === 'Memory')
																?.ValidValuesMD.find(
																	(value) =>
																		get(v, 'U_Memory', '') === value.Value,
																)?.Description || ''
														: ''

												const condition =
													get(v, 'U_Condition', '') !== ''
														? userFields
																?.find((item) => item.Name === 'Condition')
																?.ValidValuesMD.find(
																	(value) =>
																		get(v, 'U_Condition', '') === value.Value,
																)?.Description || ''
														: ''

												return (
													<tr
														key={i}
														onClick={() => viewItem(v)}
														className="bg-white border-b  hover:bg-gray-50 "
													>
														<td
															scope="row"
															className="px-6 py-4 font-medium text-gray-900 "
														>
															{get(v, 'CardCode', '-')}
														</td>
														<td className="px-6 py-4">
															{get(v, 'CardName', '-')}
														</td>
														{/* <td className="px-6 py-4">
														{get(v, 'U_Guarantor', '-')}
													</td> */}
														<td className="px-6 py-4">
															{get(v, 'IntrSerial', '-')}
														</td>
														<td className="px-6 py-4">
															{get(v, 'Dscription', '')} {color} {memory}{' '}
															{condition}
														</td>
														<td className="px-6 py-4">
															{get(v, 'U_DaftarBet', '-')}
														</td>{' '}
														<td className="px-6 py-4">
															{get(v, 'U_Security.Name', '-')}
														</td>
														<td className="px-6 py-4">
															{get(v, 'U_Score.Name', '-')}
														</td>
														<td className="px-6 py-4">
															{new Intl.NumberFormat('fr-FR', {
																minimumFractionDigits: 2,
																maximumFractionDigits: 2,
															})
																.format(get(v, 'DueToDate', '-'))
																.replace(',', '.')}
														</td>
														<td className="px-6 py-4">
															{new Intl.NumberFormat('fr-FR', {
																minimumFractionDigits: 2,
																maximumFractionDigits: 2,
															})
																.format(
																	get(v, 'DocTotal', '-') -
																		get(v, 'PaidToDate', '-'),
																)
																.replace(',', '.')}
														</td>
														<td className="px-6 py-4">
															{new Intl.NumberFormat('fr-FR', {
																minimumFractionDigits: 2,
																maximumFractionDigits: 2,
															})
																.format(get(v, 'MonthlyTotal', '-'))
																.replace(',', '.')}
														</td>
														<td className="px-6 py-4">
															{moment(get(v, 'DocDate', '-')).format(
																'DD.MM.YYYY',
															)}
														</td>
														<RenderTableRow
															value={get(v, 'U_COMMENTS.U_Text', '')}
														/>
														<RenderTableRow
															value={
																get(v, 'U_COMMENTS.U_CreateTime', '')
																	? moment(
																			get(v, 'U_COMMENTS.U_CreateTime', ''),
																		).format('YYYY-MM-DD HH:mm')
																	: ''
															}
														/>
													</tr>
												)
											})
										) : (
											<tr>
												<td colSpan="10">
													<Empty
														description={t('noInfo')}
														image={Empty.PRESENTED_IMAGE_SIMPLE}
													/>
												</td>
											</tr>
										)}
									</tbody>
								</table>
							</div>
							<div className="topCard">
								<div className="flex items-center gap-2 ">
									<Button
										disabled={currentPage === 0}
										className={'btn'}
										onClick={oldData}
									>
										{'<'}
									</Button>
									<p>{currentPage / 10 + 1 || 1}</p>
									<Button
										disabled={data.length < 10}
										className={'btn'}
										onClick={newDatas}
									>
										{'>'}
									</Button>
								</div>
							</div>
						</>
					)}
				</div>
			</AllProductsStyle>
			<>
				<ErrorModal
					getRef={(r) => {
						errorRef.current = r
					}}
				/>
			</>
		</Layout>
	)
}

export default AllProducts
